import FieldDropdown from "../dropdown/dropdown"
import FieldConfig from "../../proto/field-config"
import {GROUP_INFO} from "../../../gd/const/fields/field2-groups"
import FieldStatus_PopoverOption from "./components/popover/option"
import FieldStatus_InlineValueNotEmpty from "./components/inline-edit/value-not-empty"
import ImportFromCSVModule from "../../../gd-modules/import-from-csv/import-from-csv-module"
import FieldStatus_ConditionForm from "./render/condition"
import {ProjectSystemType} from "../../../model2/project/types"
import {EntityType} from "../../../gd/const/item"
import {SortDirection} from "../../../data-structures/sort"
import ItemModel from "../../../model2/item/item-model"
import {FieldFilterType, FieldGroupAllPossibleValues_Params} from "../../proto/types"
import {FieldDropdown_filterValuesFiller} from "../../conditions/dropdown"
import Filter from "../../../manager/filters/manager/filter"
import {
    FieldStatus_filterGetOptions
} from "../../conditions/functions/get-filter-options"
import {AggregateFunctionType} from "../../../data-structures/aggregators/types"
import FieldStatus_TableCellCalculated from "./render/table/calculated/table-cell-calculated"
import FieldStatus_AggregateCell from "./render/aggregate/aggregate-cell"
import ItemModelV2 from "../../../model2/item2/item-model"
import TaskStatusManager from "../../../gd/manager/task-status-manager"
import FieldStatus_BoardAggregate from "./render/aggregate/board-aggregate"
import FieldStatus_ViewGlist from "./render/view/view-glist"

export default class FieldStatus extends FieldDropdown {

    FIELD_DEFAULT_WIDTH = 150

    constructor(config:FieldConfig) {
        super(config)

        // options and edit is not implemented for status yet

        this.typeLabel          = "Status"
        this.typeGroup          = GROUP_INFO
        this.typeDescription    = "Status field"

        this.filterType         = FieldFilterType.DROPDOWN
        this.icon               = 'i5-statuses'

        // special
        this.options            = _.get(config, 'options', gd.session.statuses.toOptions()) // [{value, label, color},...]

        _.assign(this.classes, {
            inlineValueClass    : ''        // used to redefine default width in InlineValueNotEmpty
        })

        this.hasCalculatedValues                    = true
        this.isGroupByAllOptionsAvailable           = true

        this.components.PopoverOption               = FieldStatus_PopoverOption
        this.components.InlineValueNotEmpty         = FieldStatus_InlineValueNotEmpty

        this.renderComponents.conditionForm         = FieldStatus_ConditionForm
        this.renderComponents.filterForm            = FieldStatus_ConditionForm

        this.renderComponents.tableCellCalculated   = FieldStatus_TableCellCalculated
        this.renderComponents.aggregateCell         = FieldStatus_AggregateCell
        this.renderComponents.boardAggregate        = FieldStatus_BoardAggregate
        this.renderComponents.glistView             = FieldStatus_ViewGlist

        this.filterValuesFiller                     = FieldDropdown_filterValuesFiller
    }

    normalizeToCSVValue(model: any): any {
        let res

        // check item is task or project (systemType for both of them are of numeric value)
        if (model.taskTypeId) {
            res = gd.session.statuses.get(model.statusId).name
        } else {
            switch (model.systemType){
                case ProjectSystemType.FOLDER       :
                case ProjectSystemType.PAGE         :
                case ProjectSystemType.WHITEBOARD   :
                case ProjectSystemType.CATEGORY     :
                case ProjectSystemType.SECTION      :
                case ProjectSystemType.LINK         :
                case ProjectSystemType.EMBED        :
                case ProjectSystemType.BACKLOG      :
                case ProjectSystemType.TAG          :
                    res = gd.const.project.workfolderStatusList[model.systemStatus]
                    break

                case ProjectSystemType.SPRINT   :
                    res = gd.const.project.sprintStatusList[model.systemStatus]
                    break

                default                         :
                    res = gd.session.statuses.get(model.statusId).name
                    break
            }
        }
        return res
    }

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        value = value.trim()

        // find status by name
        const allStatuses = gd.session.statuses.filterByCompany(gd.companyId).models

        const searchValue = value.toLowerCase()
        const status = _.find(allStatuses,(status=>
            !status.isDeleted && status.name.toLowerCase() === searchValue
        ))

        if (status) {
            return status.id
        } else {
            return undefined
        }
    }

    listItemSortFunctions(sort: SortDirection):any {
        const functionsArray = [
            ((listItem: ItemModel)=>{
                let result = 0

                switch (listItem.type) {
                    case EntityType.PROJECT:
                        switch (listItem.project.systemType) {
                            case ProjectSystemType.FOLDER:
                            case ProjectSystemType.BACKLOG:
                            case ProjectSystemType.SPRINT:
                            case ProjectSystemType.TAG:
                                result = listItem.project.systemStatus
                                break

                            default:
                                const status = gd.session.statuses.get(listItem.project.statusId)
                                result = status ? status.systemStatus : listItem.project.systemStatus
                                break
                        }
                        break

                    case EntityType.TASK:
                        const status = gd.session.statuses.get(listItem.task.statusId)
                        result = status ? status.systemStatus : listItem.task.systemStatus
                        break
                }

                return result;
            }),
            ((listItem: ItemModel)=>{
                let result = 0

                switch (listItem.type) {
                    case EntityType.TASK:
                        let taskType = gd.session.taskTypes.get(listItem.task.taskTypeId)
                        if (taskType) {
                            let taskTypeStatus = taskType.statuses?.getByStatusId(listItem.task.statusId)
                            if (taskTypeStatus) result = taskTypeStatus.sortPosition
                        }
                        break
                }

                return result;
            }),
            ((listItem: ItemModel)=>{
                let result = 0

                switch (listItem.type) {
                    case EntityType.PROJECT:
                        switch (listItem.project.systemType){
                            case ProjectSystemType.WORKFOLDER:
                            case ProjectSystemType.BACKLOG:
                            case ProjectSystemType.TAG:
                                result = gd.const.project.workfolderStatusList[listItem.project.systemStatus]
                                break

                            case ProjectSystemType.SPRINT:
                                result = gd.const.project.sprintStatusList[listItem.project.systemStatus]
                                break

                            default:
                                const status = gd.session.statuses.get(listItem.project.statusId)
                                result = status ? status.name.toLowerCase() : gd.const.project.workfolderStatusList[listItem.project.systemStatus]
                                break
                        }
                        break

                    case EntityType.TASK:
                        const status = gd.session.statuses.get(listItem.task.statusId)
                        result = status ? status.name.toLowerCase() : 0
                }

                return result
            }),
        ]

        const directionsArray = [sort, sort, sort]

        return {
            functions   : functionsArray,
            directions  : directionsArray
        }
    }

    async filterGetOptions(filter: Filter): Promise<Option[]> {
        return await FieldStatus_filterGetOptions(this, filter)
    }

    /** AGGREGATE **/
    getAggregateOptions(): any {
        return [
            AggregateFunctionType.SUMMARY_COUNT
        ]
    }

    /** GROUP BY **/
    groupAllPossibleValues(params: FieldGroupAllPossibleValues_Params): any[] {
        if (params.project) {
            // if a project is provided, combine:
            // 1. all task statuses inherited from the project (e.g. configured workflow statuses)
            // 2. all statuses actually used by the itemModels
            return _.union(
                params.project.getInheritedTaskStatuses(),
                _.map(params.items, (itemModel: ItemModelV2) => itemModel.task.statusId)
            )
        } else {
            let allPossibleStatuses: ID[] = []

            // 1. find all unique project IDs referenced by the items
            const projectIds = _(params.items)
                .map((itemModel: ItemModelV2) => itemModel.task.projectId)
                .uniq()
                .value()

            // 2. collect all status IDs
            const overriddenTaskStatuses: Record<ID, ID[]> = {}
            // 2.1. collect all status IDs for projects if they have overridden statuses
            _.map(projectIds, (id: ID) => {
                const overriddenStatuses = TaskStatusManager.getTaskStatuses({ projectId: id }, { idOnly: true })
                if (overriddenStatuses?.length > 0) {
                    overriddenTaskStatuses[id] = overriddenStatuses
                    allPossibleStatuses = allPossibleStatuses.concat(overriddenStatuses)
                }
            })

            // 2.2 for each item, ensure that task type specific statuses are also included
            const taskTypeStatuses: Record<ID, ID[]> = {}
            _.map(params.items, (itemModel: ItemModelV2) => {
                // skip if we've already processed statuses for this item’s project or task type
                if (
                    !!overriddenTaskStatuses[itemModel.task.projectId] ||
                    !!taskTypeStatuses[itemModel.task.taskTypeId]
                ) {
                    // do nothing
                } else {
                    // retrieve statuses associated with task type
                    const taskStatuses = TaskStatusManager.getTaskStatuses({ taskTypeId: itemModel.task.taskTypeId }, { idOnly: true })
                    taskTypeStatuses[itemModel.task.taskTypeId] = taskStatuses
                    allPossibleStatuses = allPossibleStatuses.concat(taskStatuses)
                }

                // always add the item's current status in case it's not in the above sets
                allPossibleStatuses.push(itemModel.task.statusId)
            })

            return _.orderBy(_.uniq(allPossibleStatuses),
                [
                    // null/undefined values are sorted first/last depending on direction
                    (value: any) => {
                        return _.isNil(value) ? 0 : 1
                    },
                    // actual group value using field sort function
                    (value: any) => {
                        return this.groupSortValue(value, params.groupBy)
                    },
                ],
                [
                    params.groupBy.sortDirection,
                    params.groupBy.sortDirection
                ],
            )
        }
    }
}
